<template>
  <div class="Schedule">
    <el-button type="primary" plain size="mini" @click="getWorkFlow">{{$t('schedule.flowChart')}}</el-button>
    <el-scrollbar ref="scrollbar">
      <Timeline style="height:calc(100vh - 51px - 32px)" v-if="scheduleListData.length">
        <TimelineItem v-for="(item,index) in scheduleListData" :key="index">
          <i v-if="item.dealType===0||index===scheduleListData.length-1" class="el-icon-star-on" slot="dot" style="color:#f56c6c;font-size:16px"></i>
          <p class="time" :style="{'color': theme.main}" v-if="item.dealType!==0">
            {{item.handler}}{{item.submissionOpinion?':':''}}
            {{item.submissionOpinion}}
          </p>
          <p class="content" v-if="item.description!==''&&item.description!==null&&item.dealType!==0">
            <span>{{$t('schedule.description')}}:</span>
            {{item.description.substring(0, 2)}}
          </p>
          <p class="content" v-if="item.dealType!==0">
            <span>{{$t('schedule.dealDate')}}:</span>
            {{item.dealDate?formatter(item.dealDate):''}}
          </p>
          <p class="content" :style="item.dealType===0?'padding:0':''">            
            <span>{{$t('schedule.task')}}:</span>
            <span v-show="false" v-if="item.dealType===0">{{getCurrentHandler(item)}}</span>
            <template>{{item.name}}</template>
          </p>
          <template v-if="item.dealType===0&&item.list&&item.list.length">
            <p class="content">
              <span>{{$t('schedule.handler')}}:</span>
              <i style="font-style:normal">{{item.list.slice(0,2).join('，')}}</i>
              <i style="font-style:normal" v-if="item.list.length>2">
                等
                <el-link type="primary" @click="handleList(item)">{{item.list.length}}</el-link>
                人
              </i>
            </p>
          </template>
          <!-- <p class="content" v-if="item.submissionOpinion"><span>{{$t('schedule.opinion')}}:</span>{{item.submissionOpinion}}</p> -->
          <p class="content" v-if="item.opinionNote&&item.dealType!==0"><span>{{$t('schedule.note')}}:</span>{{item.opinionNote}}</p>
          
        </TimelineItem>
      </Timeline>
      <span v-else style="display:block;text-align:center;padding-top:30vh">{{$t('workflow.noneSchedule')}}</span>
    </el-scrollbar>
    <el-dialog
      append-to-body
      :modal="false"
      class="schedule-dialog"
      :visible.sync="dialogVisible"
      width="980px">
      <div style="height:500px" v-loading="loading">
        <template v-if="currentNode.handler&&currentNode.handler.length">
          <div class="float-bar" :style="{'color': theme.main}">
            {{$t('schedule.handler')}}：
            <span>{{currentNode.handler.slice(0,5).join('，')}}</span>
            <span v-if="currentNode.handler.length>5">
              等
              <el-link type="primary" @click="showAllHandler">{{currentNode.handler.length}}</el-link>
              人
            </span>
          </div>
        </template>
        <transition name="fade">
          <flow-graph 
            v-if="dialogVisible"
            :diagramData="diagramData"
            @handleFlowNodeClick="handleFlowNodeClick"
            @clearSelection="clearSelection"/>
        </transition>
      </div>
       
    </el-dialog>
    <el-dialog
      v-if="handler"
      class="handlerDialog"
      append-to-body
      :title="$t('schedule.handler')"
      :visible.sync="handlerVisiable"
      width="500px">
      <div class="warp" v-if="handler.length">
        <template v-for="(item,index) in handler.slice((pageIndex-1)*pageSize,pageIndex*pageSize)">
          <div class="item" :key="index">
            <span>{{item}}</span>
          </div>
        </template>
      </div>
      <div class="warp" v-else style="text-align:center;padding-bottom:20px">
        {{$t('status.noData')}}
      </div>
      <el-pagination
        v-if="handler.length"
        layout="prev, pager, next"
        :page-size="18"
        :total="handler.length"
        @current-change="handleCurrentChange"
        :current-page="pageIndex">
      </el-pagination>      
    </el-dialog>
  </div>  
</template>
<script>
import FlowGraph from './FlowGraph'
import { getWorkflowChart, getTodoList } from '@/api/workFlow'
import { mapGetters } from 'vuex'
import { parseTime } from '@/utils'
export default {
  name: 'Schedule',
  components: {
    FlowGraph
  },
  props: {
    instanceId: {
      default: ''
    },
    workFlowId: {
      default: 0
    },
    unfinished: {
      type: Array,
      default: []
    },
    scheduleList: {
      type: Array,
      default: []
    }
  },
  computed: {
    ...mapGetters(['theme']),
    scheduleListData() {
      if (this.currentNodeId) {
        return this.scheduleList.filter(sl => sl.activityId === this.currentNodeId)
      } else {
        return this.scheduleList
      }
    }
  },
  watch: {
    scheduleList() {
      this.$nextTick(this.$refs.scrollbar.update)
    },
    dialogVisible() {
      this.currentNodeId = undefined
      this.currentNode = {}
      this.pageIndex = 1
    }
  },
  data() {
    return {
      handler: [],
      pageIndex: 1,
      pageSize: 18,
      handlerVisiable: false,
      currentNode: {},
      currentNodeId: undefined,
      dialogVisible: false,
      loading: false,
      diagramData: []
    }
  },
  methods: {
    getCurrentHandler(item) {
      if(!item.loaded) {
        getTodoList(item.instanceId, item.activityId).then(response => {
          this.$set(item, 'list', response.data.handler)
          this.$set(item, 'loaded', true)
        })
      }
      
    },
    handleList(item) {
      getTodoList(item.instanceId, item.activityId).then(response => {
        this.handler = response.data.handler
        this.handlerVisiable = true
        this.pageIndex = 1
      })
    },
    handleCurrentChange(val) {
      this.pageIndex = val
    },
    showAllHandler() {
      this.handlerVisiable = true
    },
    clearSelection() {
      this.currentNodeId = undefined
      this.currentNode = {}
      this.pageIndex = 1
    },
    handleFlowNodeClick(val) {
      this.currentNodeId = val.id
      this.currentNode = val
      this.pageIndex = 1
      if (val.figure === 'StopSign' && !val.handler) {
        this.getTodoList(val.id)
      }
    },
    getTodoList(activityId) {
      getTodoList(this.instanceId, activityId).then(response => {
        this.$set(this.currentNode, 'handler', response.data.handler)
        this.handler = response.data.handler
      })
    },
    getWorkFlow() {
      this.dialogVisible = true
      this.loading = true
      getWorkflowChart(this.workFlowId).then(response => {
        this.diagramData = response.data
        this.diagramData.nodeDataArray.forEach(dn => {
          dn.fill = '#cbcbcb'
        })
        let currentId = this.scheduleList.map(sl => { return sl.activityId })
        currentId = Array.from(new Set(currentId))
        currentId.forEach((c, index) => {
          const current = this.diagramData.nodeDataArray.find(dd => dd.id === c)
          if (current) {
            current.fill = index === 0 ? '#409eff' : '#01cc65'
          }
        })
        this.unfinished.forEach(id => {
          const current = this.diagramData.nodeDataArray.find(dd => dd.id === id)
          if (current) {
            current.fill = '#e6a23c'
            current.figure = 'StopSign'            
          }
        })

        this.loading = false
      })
    },
    formatter(val) {
      return parseTime(val, '{y}-{m}-{d} {h}:{i}')
    }
  }
}
</script>
<style lang="scss">
  .handlerDialog{
    .warp{
      overflow: hidden;
    }
    .item{
      width:33%;
      text-align:center;
      float:left;
      margin-bottom:10px;
      font-size: 16px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .el-pagination{
      text-align: center;
    }
  }
  .schedule-dialog{
    .el-dialog__header{
      display: none;
    }
    .el-dialog__body{
      position: relative;
    }
    .float-bar{
      position: absolute;
      top: 10px;
      left: 0;
      width: 100%;
      text-align: center;
      font-size: 16px;
      z-index: 99;
    }
    a.el-link{
      display: inline-block !important;
      padding: 0 5px;
      text-decoration: underline;
    }
  }
  .Schedule{
    position: relative;
    .el-button{
      position: absolute;
      top: -55px;
      right:30px;
    }
    .time{
      font-size: 14px;
      font-weight: bold;
      line-height: 16px;
    }
    .content{
      color: #333;
      padding-top: 6px;
      max-height:60px;
      overflow: hidden;
      .el-link{
        display: inline-block !important;
        text-align: center;
        margin-top: -2px;
        font-size: 12px !important;
        .el-link--inner{
          text-decoration: underline;
          color:#333;
          width: auto;
        }        
      }
      span{
        color: #99a9bf; 
        font-weight: 600;
        display: inline-block;
        width: 60px;
      }
    }
  }
 
</style>